import {
  GET_INVENTORY_REPORT_REQUEST,
  GET_INVENTORY_REPORT_SUCCESS,
  GET_INVENTORY_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getinventory = (token, values) => (dispatch) => {
  dispatch({ type: GET_INVENTORY_REPORT_REQUEST });
  const newData = {
    location_id: values.location === "All" ? null : values.location
};

  return axios({
    method: "POST",
    url: `${BASEURL}getAll/inventory`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_INVENTORY_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_INVENTORY_REPORT_ERROR,
        payload: [],
      });
    });
};
